import React from 'react';
import pluralize from 'pluralize';
import { START } from 'shared/data/quoteSteps';

import HowItWorks from 'shared/product_tabs/tab_assembly/components/HowItWorks';
import PriceMatrix from 'shared/components/price/PriceMatrix';

const PriceMX = (props) => {
  const {
    quote,
    quoteStep,
    parametersChanged,
    onPriceSelect,
    parameters,
  } = props;

  const lineItem = quote.line_items.find((i) => i.product_key === 'assembly-mx');

  return (
    <div className="price-mx">
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="text-uppercase mb-0">Mexico PCB Assembly</h2>
      </div>
      <div className="row">
        <div className="col-12">
          <PriceMatrix
            leadTimeText={(lt) => `${pluralize('week', lt)}`}
            tableStripe
            lineItem={lineItem}
            parametersChanged={parametersChanged}
            onPriceSelect={onPriceSelect}
            parameters={parameters}
            quoteStep={quoteStep} />
        </div>
      </div>
      <div className="row">
        <HowItWorks />
      </div>
    </div>
  );
};

export default PriceMX;
